import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import CircularProgress from 'material-ui/CircularProgress'

import HeaderRow from './HeaderRow'
import WorkerRow from './WorkerRow'

import './WeekView.css'

const DISPLAY_LENGTH = 7
const WEEK_START_TYPE = 'week'

export default class WeekView extends React.Component {

  static propTypes = {
    selectedWorkers: PropTypes.array,
    dateStr: PropTypes.string.isRequired,
    onDayHeaderClicked: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      workers: props.selectedWorkers,
      dateStr: moment(props.dateStr).startOf(WEEK_START_TYPE).format(),
      days: this.computeDays(props.dateStr, DISPLAY_LENGTH)
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      workers: nextProps.selectedWorkers,
      dateStr: moment(nextProps.dateStr).startOf(WEEK_START_TYPE).format(),
      days: this.computeDays(nextProps.dateStr, DISPLAY_LENGTH)
    })
  }

  computeDays(dateStr, maxDays) {
    const result = []
    const todayKey = moment().startOf('day').format('YYYY-MM-DD')
    const dateObj = moment(dateStr).startOf(WEEK_START_TYPE)
    for (let i = 0; i < maxDays; ++i) {
      const newDateKey = dateObj.format('YYYY-MM-DD')
      let newDisplayName = dateObj.format('ddd, MMM D')
      let isToday = false
      if (todayKey === newDateKey) {
        newDisplayName = 'Today'
        isToday = true
      }
      result.push({key: newDateKey, displayName: newDisplayName, isToday: isToday})
      dateObj.add(1, 'd')
    }
    return result
  }

  render() {
    return (
      <div style={styles.container}>
        <HeaderRow
          key='header'
          days={this.state.days}
          onDayHeaderClicked={this.props.onDayHeaderClicked} />
        <div style={styles.workers}>
          <div style={{ width: '100%', height: '100%', position:'relative' }}>
            <div style={{ position:'absolute', left:0, top:0, width:'100%', height: '100%', overflowY: 'scroll' }}>
              { this.state.workers
                ? this.state.workers.map(worker =>
                  <WorkerRow
                    key={worker.userId}
                    worker={worker}
                    dateStr={this.state.dateStr}
                    days={this.state.days}/>)
                : <CircularProgress size={60} thickness={2} style={{ margin: 60 }} />
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  workers: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    height: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/schedule/week/WeekView.js